import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box
} from '@mui/material';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import DescriptionIcon from '@mui/icons-material/Description';
import HistoryIcon from '@mui/icons-material/History';

const DashboardInicio = () => {
  const navigate = useNavigate();

  const tarjetas = [
    {
      titulo: 'Análisis de Síntomas',
      descripcion: 'Describe tus síntomas y obtén una evaluación preliminar',
      icono: <MedicalServicesIcon sx={{ fontSize: 40 }} />,
      ruta: '/nueva-consulta',
      color: '#4CAF50'
    },
    {
      titulo: 'Análisis de Exámenes',
      descripcion: 'Sube tus exámenes médicos para su análisis',
      icono: <DescriptionIcon sx={{ fontSize: 40 }} />,
      ruta: '/analisis-examenes',
      color: '#2196F3'
    },
    {
      titulo: 'Historial de Casos',
      descripcion: 'Revisa tu historial médico y consultas anteriores',
      icono: <HistoryIcon sx={{ fontSize: 40 }} />,
      ruta: '/casos',
      color: '#9C27B0'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
        ¿Qué deseas hacer hoy?
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {tarjetas.map((tarjeta, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: 6
                }
              }}
            >
              <CardActionArea 
                onClick={() => navigate(tarjeta.ruta)}
                sx={{ height: '100%' }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      p: 2
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: tarjeta.color,
                        borderRadius: '50%',
                        p: 2,
                        mb: 2,
                        color: 'white'
                      }}
                    >
                      {tarjeta.icono}
                    </Box>
                    <Typography gutterBottom variant="h5" component="h2">
                      {tarjeta.titulo}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {tarjeta.descripcion}
                    </Typography>
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default DashboardInicio; 